<template>
  <div>
    <div class="top">
      <div>
        订单状态：
        <el-select v-model="orderStatus" @change="ccc">
          <el-option value="" label="全部"></el-option>
          <el-option value="0" label="待制作"></el-option>
          <el-option value="1" label="已制作"></el-option>
          <el-option value="2" label="已出品"></el-option>
        </el-select>
      </div>
      <div>
        <el-button type="text" @click="logOut">退出登录</el-button>
      </div>
    </div>
    <div class="body">
      <div class="left">
        <el-table
          :data="tableDate"
          border
          style="width: 100%"
          :header-cell-style="{
            background: '#00aa84',
            color: '#fff',
            textAlign: 'center',
          }"
          id="tableA"
          height="calc(100vh - 80px - 60px)"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="roomNum" label="房间号" />
          <el-table-column prop="lockPlateNum" label="手牌号" width="80" />
          <el-table-column prop="itemName" label="商品名称" />
          <el-table-column prop="number" label="数量" />
          <el-table-column prop="amount" label="金额" />
          <el-table-column label="已等待">
            <template slot-scope="scope">
              <div v-if="scope.row.wait">
                {{ `${scope.row.wait}分钟` }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderUserNumber" label="下单人" />
          <el-table-column prop="orderTime" label="下单时间" width="200" />
          <el-table-column prop="receivingNumber" label="接单人" />
          <el-table-column prop="produceNumber" label="出品人" />
          <el-table-column prop="produceName" label="出品部" />
          <el-table-column prop="description" label="备注" />
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" v-if="scope.row.orderStatus === '待制作'" plain @click="detel(scope.row.id)">
                接单
              </el-button>
              <el-button type="primary" v-if="scope.row.orderStatus === '已制作'" plain @click="detels(scope.row.id)">
                出品
              </el-button>
              <el-button type="primary" plain v-print="printObj" v-if="false"> 打印 </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagesize">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <div class="voiceBroadcast">
        <div class="title">语音播报列表</div>
        <div style="padding-top: 20px">
          <div class="langText" v-for="(item, index) in items" :key="index">
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="20%"
      :before-close="() => {
        dialogVisible = false
      }"
    >
      <span style="font-size: 20px;">开始接单！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import {
  businessProduceOrderList,
  businessReceivingOrders,
  businessProduceOrderProduce,
  businessProduceOrderWaterBarList,
  text2Audio,
  callServiceMessage
} from "@/api/produceOrder.js";
// import Voice from "@/utils/QS-baiduyy.js"; //语音合成
import Speech from "speak-tts"
import { parseTime } from '@/utils/ruoyi'

let notifyData  = {}

let audioFiles = []
let audioPool = false

export default {
  data() {
    return {
      tableDate: [],
      items: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      printObj: {
        id: "table_B", // 这里是要打印元素的ID
        popTitle: "消费排序列表", // 打印的标题
        extraCss: "", // 打印可引入外部的一个 css 文件
        extraHead: "", // 打印头部文字
      },
      orderStatus: "",
      txt: "播报一条消息",
      speech: null,

      loadPages: null,
      dialogVisible: false
    };
  },
  created() {
    this.getDataList();
    // console.log(window.localStorage.getItem("item1"));
    !!window.localStorage.getItem("item1") &&
      [...JSON.parse(window.localStorage.getItem("item1"))].forEach((item) => this.items.push(item));
    
    this.loadPage()
    setTimeout(() => {
      this.dialogVisible = true
    }, 200)
  },
  mounted() {
    // window.setTimeout(() => {
    //   this.$socket.send(
    //     JSON.stringify({
    //       msgId: Date.now(),
    //       type: 26,
    //       data: JSON.stringify("aaa"),
    //       authorization: getToken(),
    //     })
    //   );
    // }, 200);
    this.createdList();
    this.speechInit()

    let _this = this
    window.opsMessage = (val, key) => {
      _this.callServiceMessageOps(val, key)
    }
  },
  beforeDestroy() {
    console.log("关闭定时器")
    window.clearInterval(this.loadPages)
  },
  methods: {
    loadPage() {
      window.clearInterval(this.loadPages)
      this.loadPages = window.setInterval(() => {
        this.getDataList();
      }, 30000)
    },
    async logOut() {
      this.$confirm("确定注销并退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.href = "/login";
          });
        })
        .catch(() => {});
    },
    // 订单状态的修改事件
    ccc(val) {
      this.orderStatus = val;
      this.getDataList();
    },
    detel(id) {
      businessReceivingOrders(id).then((res) => {
        if (res.code === 200) {
          this.getDataList();
          this.$message.success("接单成功");
        }
      });
    },
    detels(id) {
      businessProduceOrderProduce(id).then((res) => {
        if (res.code === 200) {
          this.getDataList();
          this.$message.success("出品成功");
        }
      });
    },
    getDataList() {
      businessProduceOrderWaterBarList({
        orderStatus: this.orderStatus,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        orderType: "0",
      }).then((res) => {
        if (res.code !== 200) return;
        this.tableDate = res.data;
        this.total = res.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getDataList();
    },
    createdList() {
      this.$socketBus.$on("ws-message", this.messageSocket);
    },
    messageSocket(obj) {
      if (obj.type == 16 || obj.type == 26 || obj.type == 23) {
        console.log(obj, "messageSocket");
        if (this.items.length > 15) {
          this.items.splice(this.items.length - 1, 1)
        }
        this.items.unshift({ text: obj.data.message + ' ' + parseTime(new Date().getTime(), "{d}/{h}:{i}") })
        window.localStorage.setItem("item1", JSON.stringify(this.items));
        // this.speak(obj.data.message);
        this.textToAudio(obj.data)
        this.getDataList();
        
        if (obj.type == 23) {
          this.callNotify(obj.data)
        }
      }
    },
    async textToAudio(val) {
      let texts = ''
      try {
        texts = val.voiceTexts || [val.message]
      } catch (error) {
        texts = [val.message]
      }
      let { data } = await text2Audio({ texts })
      this.awaitPlay(data)
    },
    awaitPlay(data) {
      audioFiles = [...audioFiles, ...data]
      if (audioPool) {
        return
      } else {
        audioPool = true
        this.playNext(audioFiles[0])
      }
    },
    playNext(file) {
      let _this = this
      let audioContext = new Audio(process.env.VUE_APP_BASE_fileURL + file)
      audioContext.play();
      audioContext.addEventListener('canplay', () => {
        
      })
      audioContext.addEventListener('ended', () => {
        audioFiles.splice(0, 1)
        if (audioFiles.length > 0) {
          _this.playNext(audioFiles[0])
        } else {
          audioPool = false
          audioFiles = []
          console.log('播放完成');
        }
      })
    },
    speechInit() {
      this.speech = new Speech()
      this.speech.setLanguage("zh-CN")
      this.speech.init().then(() => {})
    },
    speak(text) {
      console.log("播放语音：", text)
      this.speech
        .speak({
          text,
          listeners: {
            onstart: () => {
              console.log("开始播放")
            },
            onend: () => {
              console.log("播放完毕")
            },
            onresume: () => {
              console.log("恢复播放")
            }
          }
        })
        .then(() => {
          console.log("成功")
        })
    },
    async callServiceMessageOps(ids, key) {
      notifyData[key].close()
      notifyData[key] = null
      await callServiceMessage({ ids: [ids] })
      this.$message.success('操作成功')
    },
    callNotify(val) {
      let html = ''
      if (val.voiceUrl) {
        html = `<audio controls>
          <source src="${process.env.VUE_APP_BASE_fileURL + val.voiceUrl}" type="audio/ogg">
          <source src="${process.env.VUE_APP_BASE_fileURL + val.voiceUrl}" type="audio/mpeg">
          您的浏览器不支持播放音频元素。
        </audio>`
      }
      let dateTime = new Date().getTime()
      let notify = this.$notify({
        title: '房间呼叫通知',
        dangerouslyUseHTMLString: true,
        message: `
          <div style="margin-bottom: 5px;">${val.message} ${parseTime(dateTime, "{d}/{h}:{i}")}</div>
          <div>${html}</div>
          <span class="link-type" onClick="opsMessage('${val.recordId}', '${dateTime}')">点击处理</span>
        `,
        showClose: false,
        duration: 0,
        type: 'success',
        customClass: 'notify-class'
      });
      console.log(notify);
      
      notifyData[dateTime] = { ...notify }
    }
    // speak(value) {
    //   console.log(value);
    //   Voice({
    //     //语音合成
    //     voiceSet: {
    //       tex: value,
    //     },
    //     audioSet: {
    //       volume: 1,
    //       obeyMuteSwitch: false,
    //     },
    //     audioCallback: {
    //       onPlay: () => {
    //         console.log("音频开始播放了");
    //       },
    //     },
    //     lineUp: true, // 加入语音队列
    //     returnAudio: false, // 返回音频对象
    //   });
    // },
  },
};
</script>
<style lang="scss" scoped>
.top {
  margin: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.body {
  margin-top: 20px;
  display: flex;
  .left {
    width: 75%;
  }
  .voiceBroadcast {
    width: 22%;
    height: calc(100vh - 150px);
    background-color: #000;
    color: #fff;
    margin-left: 2%;
    .title {
      font-size: 18px;
      height: 35px;
      background-color: #55668a;
      color: #fff;
      line-height: 35px;
      padding-left: 15px;
    }
    .langText {
      height: 35px;
      padding-left: 20px;
    }
  }
  .pagesize {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
